import { NuxtApp } from 'nuxt/app';
import ltMonitor from '@pkgs/monitor';
import { SentryEnableEnv } from '../configs/sentry.config';

const DSN_MAP = {
    // 国内 dsn
    Internal: 'https://fe200e4052f340fab7f1d2a21be917d4@sentry.linctex.com/21',
    // 海外 dsn
    Abroad: 'https://fa3aca8d77e44483bcf80ecd42c46480@sentry.linctex.com/22',
};

export default defineNuxtPlugin((nuxtApp: NuxtApp) => {
    const config = useRuntimeConfig().public;

    if (config.ENV !== SentryEnableEnv) return;

    const Sentry = ltMonitor.init({
        nuxtApp,
        dsn: config.SITE === 'abroad' ? DSN_MAP.Abroad : DSN_MAP.Internal,
        environment: config.ENV,
        tracingOrigins: ['dam.style3d.com', /^\//],
        release: 'dam1.0.0',
        whiteScreen: {
            whiteBoxElements: ['body', 'html', '#__nuxt'],
            // 白屏检测白名单
            blankPageRoutes: [],
        },
    });

    return {
        provide: {
            sentrySetUser: (user: Record<string, any>) => Sentry.setUser(user),
        },
    };
});
